import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { MembersService } from 'src/app/members/members.service';
import { Area } from 'src/app/shared/interfaces/area.interface';
import { User } from 'src/app/shared/interfaces/user.interface';
import { AreaService } from '../area.service';

/**
 * @title Basic use of `<table mat-table>`
 */

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

@Component({
  selector: 'app-area-list',
  templateUrl: './area-list.component.html',
  styleUrls: ['./area-list.component.css'],
})
export class AreaListComponent {
  displayedColumns: string[] = ['id', 'name', 'actions'];
  dataSource = new MatTableDataSource<Area>();
  searchValue = '';
  areas: Area[] = [];

  constructor(
    private areaService: AreaService,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private loadService: LoaderService
  ) {}

  ngOnInit(): void {
    this.getArea();
  }

  delete(id: number, name: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      height: '250px',
      data: { title: 'Excluir', text: ' Deseja remover a Área ? ', name: name },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.areaService
          .delete(id)
          .then((res: any) => {
            this.snackBar.open(res.message, null, {
              duration: 4000,
            });
            this.areas = res;
            this.getArea();
          })
          .catch((err: any) => {
            this.snackBar.open(err.error.message || 'Algo de errado aconteçeu');
          });
      }
    });
  }

  getArea(): void {
    this.loadService.showLoader();
    this.areaService
      .get()
      .then((res) => {
        this.areas = res;
        this.loadService.closeLoader();
      })
      .catch((err) => {
        this.loadService.closeLoader();
      });
  }

  openEdit(id: number): void {
    this.router.navigateByUrl('area/' + id);
  }

  search($val) {
    this.areaService.searchArea($val).then((res) => {
      this.areas = res;
    });
  }
}
